import React, {useContext} from "react";
import {
  Button,
  Col,
  CustomInput, FormGroup,
  Input,
  InputGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader, Row, Collapse, Card, CardBody, UncontrolledCollapse, InputGroupAddon, CardHeader, CardTitle, Form
} from "reactstrap";
import {observer} from "mobx-react-lite";
import {FormattedMessage, useIntl} from "react-intl";
import {StateContext} from "../../../../App";
import {useRouterStore} from "mobx-state-router";
import ParameterSetSelectView from "../../../elements/parameterSets/ParameterSetSelectView";
import CodeParamsTypeSelect from "../../../elements/parameters/codeType/CodeParamsTypeSelect";
import ScanParamsTypeSelect from "../../../elements/parameters/scanType/ScanParamsTypeSelect";
import CountParamsTypeSelect from "../../../elements/parameters/countType/CountParamsTypeSelect";
import PremiumParamsTypeSelect from "../../../elements/parameters/premiumType/PremiumParamsTypeSelect";
import CustomParamsTypeSelect from "../../../elements/parameters/customType/CustomParamsTypeSelect";
import DisableWrapper from "../../../../utils/disableWrapper";
import GS1ParamsTypeSelect from "../../../elements/parameters/gs1Type/GS1ParamsTypeSelect";
import Select from "react-select";
import LockButton from "src/components/elements/batch/LockButton";
import {batchTypesConstatns} from "../../../../utils/constants";

const ParameterSetModal = observer(({store, currentState}) => {
  const routerStore = useRouterStore();
  const { params } = routerStore.routerState;

  const intl = useIntl();
  const stateContext = useContext(StateContext);
  const createCodeViewState = stateContext.rootUiStore.createCodeViewState
  const editCodeState = stateContext.rootUiStore.editCodeState
  //const selectedGroupUUid = !params.id? createCodeViewState.groupSelectStore?.selectedGroup?.uuid : editCodeState?.groupSelectStore?.selectedGroup?.uuid
  const selectedGroupUUid = stateContext.rootUiStore.groupSelectStore?.selectedGroup?.uuid;
  store.parameterSetSelectState.store.setFilterOn(selectedGroupUUid)

  //TODO: PATTERN VIOLATIONS - Multiple state-modifying operations called on every render:
  // 1. Line 41: store.consumeParameterSetSelect() - State-modifying method on every render
  // 2. Line 42: store.codeParamsTypeSelectState.setConsumer() - State-modifying method on every render
  // 3. Line 43: store.scanParamsTypeSelectState.setConsumer() - State-modifying method on every render
  // 4. Line 44: store.gs1ParamsTypeSelectState.setConsumer() - State-modifying method on every render
  // 5. Line 45: store.selectOnChanges() - State-modifying method on every render
  // Correct solution: Move all state initialization/modification to route onEnter or MST actions
  // See correct pattern: src/routes/codes/index.js onEnter handlers for state initialization
  store.consumeParameterSetSelect()
  store.codeParamsTypeSelectState.setConsumer(store.selectParameters)
  store.scanParamsTypeSelectState.setConsumer(store.selectParameters)
  store.gs1ParamsTypeSelectState.setConsumer(store.selectParameters)
  store.selectOnChanges()
  const isDisabled = store.isView;
  const codeParamsTypeSelectDisabled = store.batchCodeParamTypeLock || isDisabled
  const scanParamsTypeSelectDisabled = store.batchScanParamTypeLock || isDisabled
  const countParamsTypeSelectDisabled = store.batchCountParamTypeLock || isDisabled
  const premiumParamsTypeSelectDisabled = store.batchPremiumParamTypeLock || isDisabled
  const customParamsTypeSelectDisabled = store.batchCustomParamTypeLock || isDisabled
  const gs1ParamsTypeSelectDisabled = store.batchGS1ParamTypeLock || isDisabled
  const edParamsTypeSelectDisabled = store.batchEDParamTypeLock || isDisabled

  return (
    <Card>
      <CardBody>
        <DisableWrapper isDisabled={isDisabled}>

          <Row>
            <Col sm={2}>
              <FormGroup check>
                <Input name="parameterSet"
                       type="radio"
                       id="customOpen"
                       value={store.customOpen}
                       checked={store.customOpen}
                       onClick={() => {
                         store.setCustomOpen()
                       }}
                />
                <Label check>
                  <FormattedMessage id="createQr.advancedConfigsOptions.modalButtons.new.defaultMessage"/>
                </Label>
              </FormGroup>
            </Col>
            {store.customOpen &&
              <>
                <Col sm={6}>
                  <InputGroup className="mb-3">
                    <InputGroupAddon addonType="prepend"
                      // label={intl.formatMessage({id: 'createQr.advancedConfigsOptions.modalButtons.autofillForm.defaultMessage'})}
                    >
                      Autofill Form
                      {/*<FormattedMessage id="createQr.advancedConfigsOptions.modalButtons.autofillForm.defaultMessage"/>*/}
                    </InputGroupAddon>
                    <ParameterSetSelectView store={store.parameterSetSelectState} disabled={isDisabled}/>
                  </InputGroup>
                </Col>
              </>
            }
            <Col sm={2}>
              <FormGroup check>
                <Input name="parameterSet"
                       type="radio"
                       id="noParameterSetSelectButton"
                       value={store.noParameterSetOpen}
                       checked={store.noParameterSetOpen}
                       onClick={() => {
                         store.setNoneOpen()
                       }}
                />
                <Label check>
                  None
                </Label>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            {store.customOpen &&
            <>
              <Col sm={12}>
                  {store.codeParamsTypeSelectState.store.list.length > 0 &&
                    <Row className="p-1">
                    <Label sm={2} className="text-sm-right">
                      Code
                    </Label>
                    <Col sm={8}>
                      <div className="custom-controls-stacked">
                        {!store.isLoading &&
                            <CodeParamsTypeSelect store={store.codeParamsTypeSelectState} currentState={currentState} isDisabled={codeParamsTypeSelectDisabled}/>
                        }
                      </div>
                    </Col>
                    {currentState.batchType && currentState.batchType === batchTypesConstatns.EDIT && (
                      <Col sm={2} >
                        <LockButton isDisabled={store.batchCodeParamTypeLock} onReset={store.resetCodeParams} onToggle={store.setParametersCodeParamsTypeDisabled}/>
                      </Col>
                    )}
                  </Row>}
                  {store.scanParamsTypeSelectState.store.list.length > 0 &&
                  <Row className="p-1">
                    <Label sm={2} className="text-sm-right">
                      Scan
                    </Label>
                    <Col sm={8}>
                      <div className="custom-controls-stacked">
                        {!store.isLoading &&
                          <ScanParamsTypeSelect store={store.scanParamsTypeSelectState}  isDisabled={scanParamsTypeSelectDisabled}/>
                        }
                      </div>
                    </Col>
                    {currentState.batchType && currentState.batchType === batchTypesConstatns.EDIT && (
                      <Col sm={2} >
                        <LockButton isDisabled={store.batchScanParamTypeLock} onReset={store.resetScanParams} onToggle={store.setParametersScanParamsTypeDisabled}/>
                      </Col>
                    )}
                  </Row>
                  }
                  {store.countParamsTypeSelectState.store.list.length > 0 &&
                  <Row className="p-1">
                    <Label sm={2} className="text-sm-right">
                      Count
                    </Label>
                    <Col sm={8}>
                      <div className="custom-controls-stacked">
                        {!store.isLoading &&
                          <CountParamsTypeSelect store={store.countParamsTypeSelectState}  isDisabled={countParamsTypeSelectDisabled}/>
                        }
                      </div>
                    </Col>
                    {currentState.batchType && currentState.batchType === batchTypesConstatns.EDIT && (
                      <Col sm={2} >
                        <LockButton isDisabled={store.batchCountParamTypeLock} onReset={store.resetCountParams} onToggle={store.setParametersCountParamsTypeDisabled}/>
                      </Col>
                    )}
                  </Row>
                  }
                  {store.premiumParamsTypeSelectState.store.list.length > 0 &&
                  <Row className="p-1">
                    <Label sm={2} className="text-sm-right">
                      Premium
                    </Label>
                    <Col sm={8}>
                      <div className="custom-controls-stacked">
                        {!store.isLoading &&
                          <PremiumParamsTypeSelect store={store.premiumParamsTypeSelectState}  isDisabled={premiumParamsTypeSelectDisabled}/>
                        }
                      </div>
                    </Col>
                    {currentState.batchType && currentState.batchType === batchTypesConstatns.EDIT && (
                      <Col sm={2} >
                        <LockButton isDisabled={store.batchPremiumParamTypeLock} onReset={store.resetPremiumParams} onToggle={store.setParametersPremiumParamsTypeDisabled}/>
                      </Col>
                    )}
                  </Row>
                  }
                  {store.customParamsTypeSelectState.store.list.length > 0 &&
                  <Row className="p-1">
                    <Label sm={2} className="text-sm-right">
                      Custom
                    </Label>
                    <Col sm={8}>
                      <div className="custom-controls-stacked">
                        {!store.isLoading &&
                          <CustomParamsTypeSelect store={store.customParamsTypeSelectState}  isDisabled={customParamsTypeSelectDisabled}/>
                        }
                      </div>
                    </Col>
                    {currentState.batchType && currentState.batchType === batchTypesConstatns.EDIT && (
                      <Col sm={2} >
                        <LockButton isDisabled={store.batchCustomParamTypeLock} onReset={store.resetCustomParams} onToggle={store.setParametersCustomParamsTypeDisabled}/>
                      </Col>
                    )}
                  </Row>
                  }
                {store.gs1ParamsTypeSelectState.store.list.length > 0 &&
                  <Row className="p-1">
                    <Label sm={2} className="text-sm-right">
                      GS1
                    </Label>
                    <Col sm={8}>
                      <div className="custom-controls-stacked">
                        {!store.isLoading &&
                          <GS1ParamsTypeSelect store={store.gs1ParamsTypeSelectState}  isDisabled={gs1ParamsTypeSelectDisabled}/>
                        }
                      </div>
                    </Col>
                    {currentState.batchType && currentState.batchType === batchTypesConstatns.EDIT && (
                      <Col sm={2} >
                        <LockButton isDisabled={store.batchGS1ParamTypeLock} onReset={store.resetGS1Params} onToggle={store.setParametersGS1ParamsTypeDisabled}/>
                      </Col>
                    )}
                  </Row>
                }
                <Row className="p-1">
                  <Label sm={2} className="text-sm-right">
                    <FormattedMessage id="extendedData.firstTab.multiSelect.defaultMessage" />
                  </Label>
                  {!store.isLoading &&
                  <Col sm={8}>
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        //defaultValue={store?.parameterExtendedDataSelectStore?.selectedExtendedData?.length ? store?.parameterExtendedDataSelectStore?.selectedExtendedData : []}
                        value={store?.parameterExtendedDataSelectStore?.selectedExtendedData.map((param) => ({label: param.label, uuid: param.uuid}))}
                        options={store?.parameterExtendedDataSelectStore?.optionValues()}
                        isSearchable
                        isMulti
                        onChange={(data) => store?.parameterExtendedDataSelectStore?.selectExtendedData(data)}
                        getOptionLabel={option => option.label}
                        getOptionValue={option => option.uuid}
                        placeholder="Select"
                        isDisabled={edParamsTypeSelectDisabled}
                        // dropdown placement relative to viewport
                      />
                  </Col>
                  }
                  {currentState.batchType && currentState.batchType === batchTypesConstatns.EDIT && (
                    <Col sm={2} >
                      <LockButton isDisabled={store.batchEDParamTypeLock} onReset={store.resetEDParams} onToggle={store.setParametersEDParamsTypeDisabled}/>
                    </Col>
                  )}
                </Row>
              </Col>
            </>
            }
          </Row>
          <Row className="p-1">
            <Col sm={2}>
              <Button color="secondary" id="cancel-btn" onClick={async () => {
                // editCodeState && editCodeState.modalStore.toggle()
                // createCodeViewState && createCodeViewState.modalStore.toggle()
                currentState.parameterSetModalState.setOpenView()
                currentState.modalStore.toggle()
              }}> <FormattedMessage id="createQr.advancedConfigsOptions.modalButtons.cancel.defaultMessage"/> </Button>
            </Col>
            <Col sm={10} className="text-right">
              <Button outline color="primary" onClick={async () => {
                // if (createCodeViewState) {
                //     createCodeViewState.addParameterSetToCode()
                //     createCodeViewState.modalStore.toggle()
                // }
                // if (editCodeState) {
                //   editCodeState.addParameterSetToCode()
                //   editCodeState.modalStore.toggle()
                // }
                currentState.addParameterSetToCode()
                currentState.modalStore.toggle()
              }}><FormattedMessage id="createQr.advancedConfigsOptions.modalButtons.apply.defaultMessage"/></Button>
            </Col>
          </Row>
        </DisableWrapper>
      </CardBody>
    </Card>

  );
})

export default ParameterSetModal;
